import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/images/Main.svg'


const _withScopeId = n => (_pushScopeId("data-v-34a26ad7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about_us_cont" }
const _hoisted_2 = { class: "text__confirm_about" }
const _hoisted_3 = { class: "click__vacancies" }
const _hoisted_4 = { class: "about__us_images_cont" }
const _hoisted_5 = { class: "android_lottie" }
const _hoisted_6 = { class: "java_lottie" }
const _hoisted_7 = { class: "python_lottie" }
const _hoisted_8 = { class: "flutter_lottie" }
const _hoisted_9 = { class: "front_lottie" }
const _hoisted_10 = { class: "figma_lottie" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "main__image",
  src: _imports_0,
  alt: "Main"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h2", {
        class: _normalizeClass({
          text__about_us: true,
          en: _ctx.getLanguage === 'en' ? true : false,
        })
      }, [
        _createTextVNode(_toDisplayString(_ctx.getStaticLanguage.logoHead) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.getStaticLanguage.logoHeadSpan), 1)
      ], 2),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.getStaticLanguage.textHead), 1),
      _createVNode(_component_router_link, { to: "/vacancies" }, {
        default: _withCtx(() => [
          _createElementVNode("button", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_ctx.getStaticLanguage.buttonHeadText), 1)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: "scroll-down",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.handleScroll && $options.handleScroll(...args)))
      }, [
        _createVNode(_component_lottie_animation, { path: "./images/ScrollDown.json" })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_lottie_animation, { path: "./images/Android.json" })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_lottie_animation, { path: "./images/Java.json" })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_lottie_animation, { path: "./images/Python.json" })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_lottie_animation, { path: "./images/Flutter.json" })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_lottie_animation, { path: "./images/Front.json" })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_lottie_animation, { path: "./images/Figma.json" })
      ]),
      _hoisted_11
    ])
  ]))
}